import {Injectable} from '@angular/core';

import {ConfirmationDialogComponent} from '@shared/confirmation-dialog/confirmation-dialog.component';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {Observable} from 'rxjs';
import {ModalService} from '@services/modal/modal.service';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(
      private modalService: ModalService) {
  }

  handleConfirmationDialog(messageTitle: string, messageBody: string, cancelButtonText: string, okButtonText: string): Observable<boolean> {
    // open modal
    const modalRef = this.modalService.open(ConfirmationDialogComponent);
    modalRef.componentInstance.title = messageTitle;
    modalRef.componentInstance.body = messageBody;
    modalRef.componentInstance.cancelButtonText = cancelButtonText;
    modalRef.componentInstance.okButtonText = okButtonText;

    return new Observable<boolean>((observer) => {
      modalRef.result.then(() => {
        observer.next(false);
        observer.complete();
        return false;
      }, (reason) => {
        if (reason === ModalDialogDismissOption.OK) {
          observer.next(true);
          observer.complete();
          return true;

        }
        observer.next(false);
        observer.complete();
        return false;
      });
    });
  }

  public openConfirmationDialog(title: string, message: string, cancelButton: string | null, okayButton: string) {
    const modalRef = this.modalService.open(ConfirmationDialogComponent);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.body = message;
    modalRef.componentInstance.cancelButtonText = cancelButton;
    modalRef.componentInstance.okButtonText = okayButton;
  }
}
